import React, { useEffect, useState } from 'react';
import SelectProducts from './SelectProducts/SelectProducts';
import SelectDuration from './SelectDuration';
import { useSelector } from 'react-redux';

function Modal() {
    const [visible, setVisible] = useState(false);

    const activeModal = useSelector((state) => state.collections.modal.activeModal);
    const displayModal = useSelector((state) => state.collections.modal.displayModal);

    useEffect(() => {
        if(displayModal) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [displayModal]);

    return (
        <div className={`${visible ? 'opacity-100 visible bg-[#00000080]' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out fixed z-50 size-full top-0 left-0 flex justify-center items-center`}>
            {activeModal === 'select-product' && <SelectProducts />}

            {activeModal === 'select-duration' && <SelectDuration />}
        </div>
    );
}

export default Modal;
